import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import { Dropdown } from 'semantic-ui-react';
import { FastField } from 'formik';
import api from '../../../../api';
import './InputDropdown.css';

const handleBlur = (e, { name, value }, form) =>
  form.setFieldTouched(name, value);

const handleChange = (e, { name, value }, form) =>
  form.setFieldValue(name, value);

export class InputDropdown extends PureComponent {
  state = {
    localOptions: [],
    loading: false,
  };

  fetchDialCode = query => {
    this.setState({ loading: true });
    api
      .fetchDialCode(query)
      .then(response => {
        const dialCodeList = map(response.data, data => data.dial_code);
        const sortedDialCode = uniq(dialCodeList);
        const localOptions = map(sortedDialCode, dialCode => ({
          key: dialCode,
          text: dialCode,
          value: dialCode,
        }));
        this.setState({ localOptions, loading: false });
      })
      .catch(() => this.setState({ localOptions: [], loading: false }));
  };

  componentDidMount() {
    this.fetchDialCode('');
  }

  handleSearchChange = (e, { searchQuery }) => {
    this.fetchDialCode(searchQuery);
  };

  render() {
    const { name } = this.props;
    const { localOptions, loading } = this.state;

    if (loading)
      return (
        <div
          className={classNames(
            'ui search dropdown input-dropdown label',
            'label',
          )}
        >
          ...
        </div>
      );

    return (
      <FastField
        name={`${name}_ddi`}
        render={({ field, form }) => (
          <Dropdown
            search
            onSearchChange={this.handleSearchChange}
            className={classNames('input-dropdown', 'label')}
            name={field.name}
            value={field.value}
            onChange={(e, data) => handleChange(e, data, form)}
            onBlur={(e, data) => handleBlur(e, data, form)}
            options={localOptions}
            autoComplete="off"
          />
        )}
      />
    );
  }
}

InputDropdown.propTypes = {
  name: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Form/Input/InputDropdown/InputDropdown.js